module.exports = __webpack_public_path__ + "img/1f949.6845b85.svg";